export default {
  init() {
    $('.card').hover(function() {
      $(this).find('.card-text').stop().animate({
        height: "toggle",
        opacity: "toggle",
      }, 300);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js